var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClosx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#747A8E",
  fillRule: "evenodd",
  d: "M6 4.586 1.707.293.293 1.707 4.586 6 .293 10.293l1.414 1.414L6 7.414l4.293 4.293 1.414-1.414L7.414 6l4.293-4.293L10.293.293 6 4.586Z",
  clipRule: "evenodd"
})));
export { SvgClosx as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjAwMDE1IDQuNTg1OTRMMS43MDcxOCAwLjI5Mjk2OUwwLjI5Mjk2OSAxLjcwNzE4TDQuNTg1OTQgNi4wMDAxNUwwLjI5MzExOSAxMC4yOTNMMS43MDczMyAxMS43MDcyTDYuMDAwMTUgNy40MTQzNkwxMC4yOTMgMTEuNzA3MkwxMS43MDcyIDEwLjI5M0w3LjQxNDM2IDYuMDAwMTVMMTEuNzA3MyAxLjcwNzE4TDEwLjI5MzEgMC4yOTI5NjlMNi4wMDAxNSA0LjU4NTk0WiIgZmlsbD0iIzc0N0E4RSIvPgo8L3N2Zz4K";